// https://developers.klaviyo.com/en/docs/how_to_set_up_custom_back_in_stock
// Oct 20: the form is unchanged; it now sits in our drawer (snippets/back-in-stock-modal.liquid), opened and closed
// by tt-drawer.js. Spam: a hidden field people never fill, and a minimum time to fill the form; a bot that trips
// either sees the thank-you and nothing is sent.
(function() {
  'use strict';

  var KLAVIYO_API = 'https://a.klaviyo.com/client/';
  var KLAVIYO_REVISION = '2025-01-15';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var MIN_FILL_MS = 1500;
  var openedAt = 0;

  function getModal() {
    return document.getElementById('back-in-stock-modal');
  }

  function klaviyoPost(modal, endpoint, payload) {
    var url = KLAVIYO_API + endpoint + '/?company_id=' + encodeURIComponent(modal.dataset.companyId);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function(response) {
      if (!response.ok) throw new Error('Klaviyo ' + endpoint + ' responded ' + response.status);
      return response;
    });
  }

  function profileAttributes(email, phone) {
    var attributes = { email: email };
    if (phone) attributes.phone_number = phone;
    return attributes;
  }

  function subscribeBackInStock(modal, email, phone, variantId) {
    return klaviyoPost(modal, 'back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: profileAttributes(email, phone) } },
          channels: phone ? ['EMAIL', 'SMS'] : ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    });
  }

  function subscribeToList(modal, email, phone, wantsEmail) {
    var attributes = profileAttributes(email, phone);
    attributes.subscriptions = {};

    if (wantsEmail) {
      attributes.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
    }

    if (phone) {
      attributes.subscriptions.sms = {
        marketing: { consent: 'SUBSCRIBED' },
        transactional: { consent: 'SUBSCRIBED' }
      };
    }

    return klaviyoPost(modal, 'subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: attributes } },
          custom_source: 'Back in Stock'
        },
        relationships: {
          list: { data: { type: 'list', id: modal.dataset.listId } }
        }
      }
    });
  }

  // returns E.164, '' if empty, null if invalid
  function normalizePhone(countryCode, value) {
    var digits = value.replace(/\D/g, '');
    if (!digits) return '';

    if (countryCode === '+1') {
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return digits.length === 10 ? countryCode + digits : null;
    }

    digits = digits.replace(/^0+/, '');
    return digits.length >= 7 && digits.length <= 12 ? countryCode + digits : null;
  }

  function showError(modal, message) {
    var error = modal.querySelector('[data-back-in-stock-error]');
    error.textContent = message;
    error.hidden = false;
  }

  function setTitle(modal, showSuccess) {
    modal.querySelector('[data-back-in-stock-title]').hidden = showSuccess;
    modal.querySelector('[data-back-in-stock-success-title]').hidden = !showSuccess;
  }

  function showSuccess(modal, form) {
    form.hidden = true;
    setTitle(modal, true);
    modal.querySelector('[data-back-in-stock-success]').hidden = false;
  }

  function resetModal(modal, trigger) {
    var form = modal.querySelector('[data-back-in-stock-form]');
    var itemLine = modal.querySelector('[data-back-in-stock-item-line]');
    var itemLineTemplate = trigger.querySelector('template[data-back-in-stock-item-line]');

    setTitle(modal, false);

    form.reset();
    form.hidden = false;
    form.elements.variant_id.value = trigger.dataset.variantId || '';
    form.querySelector('[type="submit"]').disabled = false;

    modal.querySelector('[data-back-in-stock-newsletter]').hidden = !modal.dataset.listId;
    modal.querySelector('[data-back-in-stock-error]').hidden = true;
    modal.querySelector('[data-back-in-stock-success]').hidden = true;
    modal.querySelector('[data-back-in-stock-product]').textContent = trigger.dataset.productTitle || '';

    itemLine.replaceChildren();
    if (itemLineTemplate) itemLine.appendChild(itemLineTemplate.content.cloneNode(true));
    itemLine.hidden = !itemLine.childElementCount;
  }

  function onSubmit(event) {
    var form = event.target.closest('[data-back-in-stock-form]');
    if (!form) return;
    event.preventDefault();

    var modal = getModal();
    var submitButton = form.querySelector('[type="submit"]');
    var email = form.elements.email.value.trim();
    var phone = normalizePhone(form.elements.country_code.value, form.elements.phone.value);
    var variantId = form.elements.variant_id.value;
    var hasList = !!modal.dataset.listId;
    var wantsEmail = hasList && form.elements.newsletter.checked;

    modal.querySelector('[data-back-in-stock-error]').hidden = true;

    if (!EMAIL_PATTERN.test(email)) {
      showError(modal, modal.dataset.invalidEmailText);
      form.elements.email.focus();
      return;
    }

    if (phone === null) {
      showError(modal, modal.dataset.invalidPhoneText);
      form.elements.phone.focus();
      return;
    }

    // A bot: the hidden field is filled, or the form was filled faster than a person could (a signed-in
    // shopper's email is already filled in, so the clock does not apply to them).
    var tooFast = Date.now() - openedAt < MIN_FILL_MS && email !== form.elements.email.defaultValue;
    if (form.elements.company.value || tooFast) {
      showSuccess(modal, form);
      return;
    }

    submitButton.disabled = true;

    // subscribe to list first, don't block the alert if it fails
    var consent = hasList && (wantsEmail || phone)
      ? subscribeToList(modal, email, phone, wantsEmail).catch(function(error) {
          console.warn('[back-in-stock] list subscription failed', error);
        })
      : Promise.resolve();

    consent
      .then(function() {
        // fall back to email only if SMS is rejected
        return subscribeBackInStock(modal, email, phone, variantId).catch(function(error) {
          if (!phone) throw error;
          console.warn('[back-in-stock] SMS alert rejected, retrying email only', error);
          return subscribeBackInStock(modal, email, '', variantId);
        });
      })
      .then(function() {
        showSuccess(modal, form);
      })
      .catch(function(error) {
        console.warn('[back-in-stock] subscription failed', error);
        showError(modal, modal.dataset.errorText);
        submitButton.disabled = false;
      });
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-back-in-stock-close]')) {
      if (window.ttDrawer) window.ttDrawer.close();
      return;
    }

    var trigger = event.target.closest('[data-back-in-stock-trigger]');
    if (!trigger) return;

    var modal = getModal();
    if (!modal || !trigger.dataset.variantId || !window.ttDrawer) return;

    event.preventDefault();
    resetModal(modal, trigger);
    openedAt = Date.now();
    window.ttDrawer.open('back-in-stock-modal');
  });

  document.addEventListener('submit', onSubmit);
})();
